var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburgerOld = function SvgHamburgerOld(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg5",
    width: 40,
    height: 40,
    preserveAspectRatio: "none",
    viewBox: "0 0 40 40"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, ".cls-1{fill:#fff}"))), /*#__PURE__*/React.createElement("g", {
    id: "Header_Buttons",
    "data-name": "Header Buttons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polygon3",
    d: "m33.64 6.88-19.39.49v4.38l19.8.99z",
    className: "cls-1",
    style: {
      fill: "#ffce41",
      fillOpacity: 1
    },
    transform: "matrix(1.67444 0 0 1.2471 -20.12 -3.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon3-0",
    d: "m33.64 6.88-19.39.49v4.38l19.8.99z",
    className: "cls-1",
    style: {
      fill: "#ffce41",
      fillOpacity: 1
    },
    transform: "matrix(-1.67444 0 0 1.2471 60.75 7.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon5",
    d: "m14.63 28.1-.38 4.09 19.8.5-.67-5.13z",
    className: "cls-1",
    style: {
      fill: "#ffce41",
      fillOpacity: 1
    },
    transform: "matrix(1.67444 0 0 1.48755 -20.12 -12.95)"
  })));
};
export default SvgHamburgerOld;